import { IsMobileContext, MOBILE_WIDTH } from 'providers/IsMobileProvider';
import { useContext, useEffect } from 'react';

export const useIsMobile = (desktopBreakpoint?: number) => {
  const context = useContext(IsMobileContext);

  useEffect(() => {
    if (desktopBreakpoint !== undefined && context?.registerBreakpoint) {
      context.registerBreakpoint(desktopBreakpoint);
      return () => {
        context.unregisterBreakpoint(desktopBreakpoint);
      };
    }
  }, [
    desktopBreakpoint,
    context?.registerBreakpoint,
    context?.unregisterBreakpoint,
  ]);

  if (!context) {
    console.warn(
      'useIsMobile was used outside of a provider, assuming isMobile to be true',
    );
    return { isMobile: true };
  }

  const breakpoint = desktopBreakpoint ?? MOBILE_WIDTH;
  return {
    isMobile: context.breakpointMap[breakpoint] ?? true,
  };
};
